import { useState, useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

import Activity from "components/DigiHapi/Activity.js";
import Notification from "components/DigiHapi/Notification";

// Redux
import { useDispatch, useSelector } from "react-redux";

import {
	SET_USER_NEW_PASSWORD,
	SET_USER_NEW_PASSWORD_CONFIRM,
	SET_PASSWORD,
	CLEAR_PASSWORD_VALIDATE,
	VALIDATE_PASSWORD_INPUTS
} from "actions/types";
import { fetchChangePassword, fetchLogout } from "actions/login";

export default function PasswordPage(props) {
	const dispatch = useDispatch();

	const {
		isFetching,
		password,
		newpassword,
		newpasswordConfirm,
		passwordErrorMsg,
		newpasswordErrorMsg,
		snackInfoMsg,
		snackErrorMsg,
		isClearPasswordValidated,
		isPwdValid
	} = useSelector(state => state.loginReducer);

	const { user } = useSelector(state => state.profileReducer);

	useEffect(() => {
		if (isClearPasswordValidated) {
			dispatch({
				type: VALIDATE_PASSWORD_INPUTS
			});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isClearPasswordValidated]);

	useEffect(() => {
		if (isPwdValid) {
			dispatch(
				fetchChangePassword({
					email: user.email,
					password,
					newpassword
				})
			);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isPwdValid]);

	const [br, setBr] = useState(false);
	const [message, setMessage] = useState(null);
	const [color, setColor] = useState("info");

	useEffect(() => {
		if (snackInfoMsg || snackErrorMsg) {
			setBr(true);
			setMessage(snackInfoMsg ? snackInfoMsg : snackErrorMsg);
			setColor(snackInfoMsg ? "info" : "danger");
			if (snackInfoMsg) {
				setTimeout(() => dispatch(fetchLogout()), 5000);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [snackInfoMsg, snackErrorMsg]);

	const changePassword = e => {
		e.preventDefault();
		dispatch({
			type: CLEAR_PASSWORD_VALIDATE
		});
	};

	const newPasswordSuccess =
		newpasswordErrorMsg === null && newpassword !== null;

	return (
		<Grid container spacing={3}>
			<Grid item xs={12} md={6}>
				<Card>
					<MDBox
						mx={2}
						mt={-3}
						py={2}
						px={2}
						variant="gradient"
						bgColor="primary"
						borderRadius="lg"
						coloredShadow="primary"
						display="flex"
						alignItems="center"
						color="white"
					>
						<Icon>lock</Icon>
						<MDTypography variant="h6" color="white" ml={1.5}>
							Changement de mot de passe
						</MDTypography>
					</MDBox>
					<MDBox p={2}>
						<Grid container spacing={3}>
							<Grid item xs={12}>
								<MDInput
									label="Mot de passe actuel *"
									id="password"
									fullWidth
									type="password"
									autoComplete="off"
									error={!!passwordErrorMsg}
									helperText={passwordErrorMsg}
									value={password || ""}
									onChange={e =>
										dispatch({
											type: SET_PASSWORD,
											value: e.target.value
										})
									}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<MDInput
									label="Nouveau mot de passe *"
									id="newpassword"
									fullWidth
									type="password"
									autoComplete="off"
									success={newPasswordSuccess}
									error={!!newpasswordErrorMsg}
									helperText={newpasswordErrorMsg}
									value={newpassword || ""}
									onChange={e =>
										dispatch({
											type: SET_USER_NEW_PASSWORD,
											value: e.target.value
										})
									}
								/>
							</Grid>
							<Grid item xs={12} md={6}>
								<MDInput
									label="Confirmer nouveau mot de passe *"
									id="confirmnewpassword"
									fullWidth
									type="password"
									autoComplete="off"
									success={newPasswordSuccess}
									error={!!newpasswordErrorMsg}
									helperText={newpasswordErrorMsg}
									value={newpasswordConfirm || ""}
									onChange={e =>
										dispatch({
											type: SET_USER_NEW_PASSWORD_CONFIRM,
											value: e.target.value
										})
									}
								/>
							</Grid>
						</Grid>
					</MDBox>
					<MDBox p={2} display="flex" justifyContent="flex-end" gap={1}>
						<MDButton
							variant="gradient"
							color="primary"
							disabled={isFetching}
							onClick={changePassword}
						>
							{isFetching ? <Activity /> : "Modifier"}
						</MDButton>
					</MDBox>
				</Card>
			</Grid>
			<Notification
				place="br"
				color={color}
				message={message}
				open={br}
				onClose={() => setBr(false)}
			/>
		</Grid>
	);
}
